<app-header></app-header>
<app-botao-chat></app-botao-chat>
<app-loading-generico [loadingGenerico]="alertLoading"></app-loading-generico>
<app-success-generico [successGenerico]="alertSucesso" (alertFechou)="fecharAlertSucesso($event)">
</app-success-generico>
<app-error-generico [errorGenerico]="alertError" (alertErrorFechou)="fecharAlertError($event)"></app-error-generico>


<div class="container py-4">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <app-breadcrumb></app-breadcrumb>
        <h1 class="titulo">Contatos</h1>
        @if (dadosContato) {
          <form class="col-12 mt-4 ps-0" [formGroup]="formulario">
            <div class="row">
              <div class="col-12 col-lg-4 mb-4">
                <div class="mb-3">
                  <label class="label-menor" for="nomeCompleto">NOME COMPLETO</label>
                  <input type="text" id="nomeCompleto" class="form-control" formControlName="nomeCompleto"
                    placeholder="Preencha com o nome">
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-4 mb-4">
                <div class="mb-3">
                  <label class="label-menor" for="cpf">CPF</label>
                  @if (dadosContato.cpf.length > 0) {
                    <input type="text" id="cpf" class="form-control disabled" formControlName="cpf"
                      placeholder="Preencha com o CPF" mask="000.000.000-00" disabled>
                  }
                  @if (dadosContato.cpf.length == undefined || dadosContato.cpf.length == 0) {
                    <input type="text" class="form-control" formControlName="cpf"
                      placeholder="Preencha com o CPF" mask="000.000.000-00">
                  }
                  @if (formControl.cpf.invalid && (formControl.cpf.dirty || formControl.cpf.touched)) {
                    <div
                      class="alert alert-danger">
                      @if (formControl.cpf.errors?.required) {
                        <div>
                          Campo obrigatório
                        </div>
                      }
                      @if (formControl.cpf.errors?.cpfValidator) {
                        <div>
                          CPF inválido
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-4 mb-4">
                <div class="mb-3">
                  <label class="label-menor" for="genero">GÊNERO</label>
                  <app-select
                    [form]="formulario"
                    name="genero"
                    id="genero"
                      [options]="[
                      { description : 'Masculino' ,
                        value : 'M'} ,
                        { description : 'Feminino' ,
                        value : 'F'}
                      ]"
                    optionValue="value"
                    optionText="description">
                  </app-select>
                </div>
              </div>
              <div class="col-12 col-md-6 col-md-6 col-lg-4 mb-4">
                <div class="mb-3">
                  <label class="label-menor" for="dataNascimento">DATA DE NASCIMENTO</label>
                  <input class="form-control d-inline m-0" dateMask [matDatepicker]="picker1" placeholder="dd/mm/aaaa" formControlName="dataNascimento" id="dataNascimento" (blur)='validadata()' >
                  <mat-datepicker-toggle matSuffix [for]="picker1" class="datepicker-custom-float"></mat-datepicker-toggle>
                  <mat-datepicker #picker1 (closed)="validadata()"></mat-datepicker>
                </div>
              </div>
              <!-- LINHA 2 -->
              <div class="col-12 col-md-6 col-lg-4 mb-4">
                <div class="mb-3">
                  <label class="label-menor" for="email">E-MAIL</label>
                  <input type="email" class="form-control" formControlName="email" id="email" placeholder="Preencha com o e-mail">
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-4 mb-4">
                <div class="mb-3">
                  <label class="label-menor" for="telefone">TELEFONE</label>
                  <input type="text" class="form-control" formControlName="telefone" id="telefone" mask="(00) 00000-0000"
                    [dropSpecialCharacters]="true" [validation]="false" placeholder="Nº do telefone">
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-4 mb-4">
                <div class="mb-3">
                  <label class="label-menor" for="ramal">RAMAL</label>
                  <input type="number" (keypress)="somenteNumeros($event)" class="form-control" formControlName="ramal" id="ramal"
                    placeholder="Nº Ramal">
                </div>
              </div>
              <!-- LINHA 3 -->
              <div class="col-12 col-md-6 col-lg-4 mb-4">
                @if (departamentos) {
                  <div class="mb-3">
                    <label class="label-menor" for="departamento">DEPARTAMENTO</label>
                    <app-select
                      [form]="formulario"
                      name="departamento"
                      id="departamento"
                      [options]="departamentoOptions"
                      defaultDescription=" "
                      optionValue="value"
                      optionText="description">
                    </app-select>
                  </div>
                }
                @if (departamentos === null) {
                  <div>
                    <div class="text-center">
                      <output class="spinner-border c-primary">
                        <span class="visually-hidden">Consultando departamentos ...</span>
                      </output>
                    </div>
                    <p class="legenda-spinner">Consultando departamentos ...</p>
                  </div>
                }
                @if (departamentos === false) {
                  <div>
                    <p class="legenda-erro">Erro ao consultar departamentos</p>
                  </div>
                }
              </div>
              <div class="col-12 col-md-6 col-lg-4 mb-4">
                @if (cargos) {
                  <div class="mb-3">
                    <label class="label-menor" for="cargo">CARGO</label>
                    <app-select
                      [form]="formulario"
                      name="cargo"
                      id="cargo"
                      [options]="cargosOptions"
                      defaultDescription="Selecionar departamento"
                      optionValue="value"
                      optionText="description">
                    </app-select>
                  </div>
                }
                @if (cargos === null) {
                  <div>
                    <div class="text-center">
                      <output class="spinner-border c-primary">
                        <span class="visually-hidden">Consultando cargos ...</span>
                      </output>
                    </div>
                    <p class="legenda-spinner">Consultando cargos ...</p>
                  </div>
                }
                @if (cargos === false) {
                  <div>
                    <p class="legenda-erro">Erro ao consultar cargos</p>
                  </div>
                }
              </div>
            </div>
          </form>
        }

        @if (mensagemErro) {
          <p class="legenda-erro mt-2 mb-4">{{mensagemErro}}</p>
        }

        @if (formulario) {
          <div class="w-100 d-flex justify-content-center mt-3">
            <button class="botao-outline me-4" (click)="voltarAbaContatos()">FECHAR</button>
            @if (formulario.valid && formularioChanges === true && dataValidator === true) {
              <button class="botao" (click)="atualizarDadosContato()"
              >SALVAR</button>
            }
            @if (!formulario.valid || formularioChanges === false || dataValidator === false) {
              <button class="botao disabled" (click)="atualizarDadosContato()"
              disabled>SALVAR</button>
            }
          </div>
        }

        @if (dadosContato === null) {
          <div>
            <div class="text-center">
              <output class="spinner-border c-primary">
                <span class="visually-hidden">Consultando dados do contato ...</span>
              </output>
            </div>
            <p class="legenda-spinner">Consultando dados do contato ...</p>
          </div>
        }

        <!-- CASO DE ERRO S -->
        @if (dadosContato === false) {
          <div class="text-center">
            <img src="/assets/img/erro.png" width="200px" alt="Erro">
            <p class="legenda-erro">Ocorreu um erro na consulta do contato.</p>
          </div>
        }

      </div>

      <!-- CARD GERENCIAR PERMISSÕES -->
      @if (idContatoPermissao && ('CadastrosDadosDaEmpresaGerenciarPermissoes' | usuarioPermissao:'Imprimir' | async)) {
        <div class="hand card card-gerenciar mt-4"
          [ngClass]="(usuarioPermissaoService.cssPorPermissoes$ | async).CadastrosDadosDaEmpresaGerenciarPermissoes"
          routerLink='/gerenciar-permissoes/{{idContatoPermissao?.idContato}}'>
          <img src="/assets/img/cadeado.png" alt="Cadeado" class="float-start me-3" height="60" width="60" alt="">
          <h2 class="titulo">Gerenciar Permissões</h2>
          <p class="paragrafo">Gerencie todos os acessos do portal</p>
        </div>
      }

    </div>
  </div>
</div>

<app-footer></app-footer>
